import MisDatosPage from 'pages/MisDatos';
import AdminClientePage from 'pages/administrador/AdminClientePage';

import { mainRoute, catchAllRoute } from '../helpers';

const administradorRoutes = [
  mainRoute('/', AdminClientePage),
  // Ley 21.719: toda persona con cuenta puede ejercer sus derechos sobre sus datos.
  mainRoute('/mis-datos', MisDatosPage),
  catchAllRoute(),
];

export default administradorRoutes;
